import { Injectable } from "@angular/core";
import { ListInfo } from "../../entities/listinfo.model";
import { NurseryModel } from "../../entities/nursery.model";
import { Observable } from "rxjs";
import { PolygonType } from "../../../crossconcern/types/polygon.type";
import { PolygonModel } from "../../entities/polygon.model";
import { PolygonList } from "../../entities/polygonlist.model";
import { ShortcutList } from "../../entities/shortcutlist.model";
import { ShortcutType } from "../../../crossconcern/types/shortcut.type";
import { ShortcutModel } from "../../entities/shortcut.model";

@Injectable()
export abstract class NurseryRepositoryInterface {

    public abstract getNurseries(visible: boolean, pageSize: number, page: number): Observable<[ListInfo, NurseryModel[]]>;

    public abstract getNursery(uuid: string): Observable<NurseryModel>;

    public abstract addNursery(body: unknown): Observable<NurseryModel>;

    public abstract editNursery(id: string, body: unknown): Observable<NurseryModel>;

    public abstract deleteNursery(id: string): Observable<{}>;

    public abstract duplicateNursery(nurseryUUID: string): Observable<NurseryModel>;

    public abstract addPhotospheres(body: FormData, nurseryUUID: string): Observable<{}>;

    public abstract addCSV(body: FormData, nurseryUUID: string): Observable<{}>;

    public abstract connectPhotospheres(nurseryUUID: string): Observable<{}>;

    public abstract getPolygons(pageSize: number, page: number, nurseryUUID?: string): Observable<PolygonList>;

    public abstract addPolygon(polygon: PolygonType): Observable<PolygonModel>;

    public abstract editPolygon(polygonUUID: string, polygon: PolygonType): Observable<PolygonModel>;

    public abstract deletePolygon(polygonUUID: string): Observable<{}>;

    public abstract getShortcuts(pageSize: number, page: number, nurseryUUID?: string): Observable<ShortcutList>;

    public abstract addShortcut(shortcut: ShortcutType): Observable<ShortcutModel>;

    public abstract editShortcut(shortcutUUID: string, shortcut: ShortcutType): Observable<ShortcutModel>;

    public abstract deleteShortcut(shortcutUUID: string): Observable<{}>;
}
